import React from "react";
import { Culture } from "../../types/culture";
import { DefectType } from "../../types/defectType";
import { translateString } from "../../translations/gridTranslationHelper";
import { renderSingleDefectName } from "../../aplUtils/defectsHelper";
import { ConsumptionDetail } from "../../types/consumptionDetail";
import { Link } from "react-router-dom";

interface ConsumptionDetailsDefectsTableProps {
    selectedConsumptionDetails: ConsumptionDetail[];
    culture: Culture;
    defectTypes: DefectType[];
}

const collapseButton = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-arrows-collapse"
        viewBox="0 0 16 16"
    >
        <path
            fillRule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8m7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0m-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0z"
        />
    </svg>
);

const expandButton = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-expand" viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2M8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10"
        />
    </svg>
);

const ConsumptionDetailsDefectsTable: React.FC<ConsumptionDetailsDefectsTableProps> = ({
    selectedConsumptionDetails,
    culture,
    defectTypes
}) => {
    const tableDivRef = React.useRef<HTMLDivElement>(null);
    const [isCollapsed, setIsCollapsed] = React.useState<boolean>(false);

    return (
        <div className="row" ref={tableDivRef}>
            <table
                id="consDefectTable"
                style={{
                    minWidth: (tableDivRef.current?.clientWidth ?? 0) - 16 ?? 0,
                    position: "absolute",
                    maxWidth: (tableDivRef.current?.clientWidth ?? 100) - 16
                }}
            >
                <thead>
                    <tr>
                        <th>{translateString("rxg_defectsTable_Defect", culture)}</th>
                        <th>{translateString("mouldNo", culture)}</th>
                        <th>{translateString("comment", culture)}</th>
                        <th>{translateString("initials", culture)}</th>
                    </tr>
                </thead>
                <tbody>
                    {!isCollapsed &&
                        selectedConsumptionDetails[0]?.defects?.map((d, e) => (
                            <tr key={e}>
                                <td>{renderSingleDefectName(d.defectId, defectTypes)}</td>
                                <td>{d.mouldNo}</td>
                                <td>{d.comment}</td>
                                <td>{d.initials}</td>
                            </tr>
                        ))}

                    <tr>
                        <td>
                            {isCollapsed &&
                            selectedConsumptionDetails.length > 0 &&
                            selectedConsumptionDetails[0].defects &&
                            selectedConsumptionDetails[0].defects.length > 0
                                ? `... (${selectedConsumptionDetails[0].defects.length})`
                                : ""}
                        </td>
                        <td></td>
                        <td></td>
                        <td className="float-right">
                            <Link to={""} onClick={() => setIsCollapsed(!isCollapsed)}>
                                {isCollapsed ? expandButton() : collapseButton()}
                            </Link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default ConsumptionDetailsDefectsTable;
